import React from 'react'
import "./main.css"


function Main() {
  return (
    <>
  <div>
        <header id="header">
          <div className="logo">
            <img id="header-img" src="https://i.postimg.cc/G2gJJtWQ/5342241-removebg-preview.png" alt="logo" />
            <p className="title">Yoga </p>
          </div>
          <nav id="nav-bar">
            <ul className="nav-link">
              <li><a href="#home">Home</a></li>
              <li><a href="#asanas">Asanas</a></li>
              <li><a href="#product_section">Products</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </nav>
        </header>
        <section id="home">
          <div className="home"> 
            <div className="home_text">
              <h1>Yoga - Path to peace</h1>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Omnis enim placeat optio ipsum reprehenderit quas sunt, sint officia molestias perferendis?</p>
              <a href className="home_btn">learn more</a>
            </div>
            <div className="home_img">
              <img src="https://i.postimg.cc/yYscgF3H/44f8eb349733cae938739e7aa249345b-removebg-preview.png" alt="succulent" />
            </div>
          </div>
        </section>
        <div id="asanas" />
        <div className="container">
          <section className="succulent_care">
            <div className="column">
              <div className="icon"><img src="https://i.postimg.cc/XY0j78rf/331-3312863-clothes-logo-icon-png-transparent-png-removebg-preview.png" alt="water" />
              </div>
              <div className="detail">
                <h3>Wear comfortable clothing</h3>
                <p>Lorem ipsum dolor sit amet.</p>
              </div>
            </div>
            <div className="column">
              <div className="icon"><img src="https://i.postimg.cc/CxWQVPd0/images-removebg-preview.png" alt="light" />
              </div>
              <div className="detail">
                <h3>Focus on your foundation</h3>
                <p>Lorem ipsum dolor sit amet.</p>
              </div>
            </div>
            <div className="column">
              <div className="icon"><img src="https://cdn-icons-png.flaticon.com/512/5115/5115266.png" alt="grow" />
              </div>
              <div className="detail">
                <h3>Be Consistent</h3>
                <p>Lorem ipsum dolor sit amet.</p>
              </div>
            </div>
          </section>
         
          <section id="product_section">
            <div>
              <h2>Products</h2>
            </div>
            <div id="products">
              <div className="product" id="succulent1">
                <img src="https://i.pinimg.com/564x/16/84/8b/16848b86cbc9118c7584c285e9162f4d.jpg" alt="" />
                <div className="plants">Plan 1</div>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aliquid, molestias?</p>
                <h3>105 $</h3>
                <button className="btn">Buy</button>
              </div>
              <div className="product" id="succulent2">
                <img src="https://i.pinimg.com/564x/cb/90/e6/cb90e6ec0b6a8148d20e3c7228855baf.jpg" alt="" />
                <div className="plants">Plan 2</div>
                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officia, qui.</p>
                <h3>170 $</h3>
                <button className="btn">Buy</button>
              </div>
              <div className="product" id="succulent3">
                <img src="https://i.pinimg.com/564x/26/7e/35/267e35e9c3ce57664fbf208ae7d942ca.jpg" alt="" />
                <div className="plants">Plan 3</div>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime, totam.</p>
                <h3>366 $</h3>
                <button className="btn">Buy</button>
              </div>
              <div className="product" id="succulent4">
                <img src="https://i.pinimg.com/564x/52/2b/ad/522bade8a5584df4f74020852c2317e8.jpg" alt="" />
                <div className="plants">Plan 4</div>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde, eveniet?</p>
                <h3>123 $</h3>
                <button className="btn">Buy</button>
              </div>
            </div>
          </section>
          <div id="contact" />
          <section id="contact_us">
            <div>
              <h2>Contact us</h2>
            </div>
            <div>
              <form id="form" className="contact_form" >
                <div className="row">
                  <input type="text" name="name" id="name" placeholder="Name" required />
                  <input type="email" name="email" id="email" placeholder="Email address" required /></div>
                <div><textarea name="message" id="message" placeholder="Your message..." defaultValue={""} /></div>
                <div><button type="submit" id="submit" className="btn">Send</button></div>
              </form>
            </div>
          </section>
          <footer>
            <ul>
              <li><a href="#">Privacy</a></li>
              <li><a href="#">Terms</a></li>
            </ul>
            <span>© 2020 Yoga footer Page</span>
          </footer>
        </div>
      </div>
      </>
  )
}



export default Main

